import React from 'react';

import IconAddlistOrange from '../../assets/images/common/icon-addlist-orange.svg';

import { MAX_DEVICE_COUNT } from '../../types/common/CommonType';
import { ErrorMessages } from '../../types/common/Messages';
import { SearchItems } from '../../types/api/SearchApiType';

import { StrongText } from '../../components/StrongSearchText';

type SearchResultRowProps = {
    searchWord?: string; // 検索条件
    searchResultRow: SearchItems; // 検索結果列
    setAddDeviceModal: (value: boolean) => void; // ボタン押下時action
    deviceListCount: number;
    setSearchItems: (value: SearchItems) => void;
    addMessage: string;
    setErrorMessages: (values: Array<string>) => void;
    setOpenErrorModal: (value: boolean) => void;
};

// 検索結果行表示
export const SearchResultRow: React.FC<SearchResultRowProps> = ({
    searchWord,
    searchResultRow,
    setAddDeviceModal,
    deviceListCount,
    setSearchItems,
    addMessage,
    setErrorMessages,
    setOpenErrorModal,
}) => {
    // マイリスト追加
    const deviceListAdd = () => {
        if (deviceListCount < MAX_DEVICE_COUNT) {
            // 機種情報を保持してmodalを開く
            setSearchItems(searchResultRow);
            setAddDeviceModal(true);
        } else {
            // 上限超える場合、エラー
            setErrorMessages([ErrorMessages.DEVICE_LIST_ADD_ERROR]);
            setOpenErrorModal(true);
        }
    };

    const SPACE = '　';

    return (
        <dl>
            <dt>
                {searchResultRow.maker_name}
                {SPACE}
                <StrongText inputString={`${searchWord}`} rowText={searchResultRow.mp_product_name} />
                {searchResultRow.mp_model_number1 && (
                    <span className='kataban'>
                        <StrongText inputString={`${searchWord}`} rowText={searchResultRow.mp_model_number1} />
                    </span>
                )}
            </dt>
            <dd>
                <button className='button is-small addlist' onClick={deviceListAdd}>
                    見積り機器に追加
                    <span className='icon is-small is-right'>
                        <img src={IconAddlistOrange} alt='' />
                    </span>
                </button>
                {addMessage && <div>{addMessage}</div>}
            </dd>
        </dl>
    );
};
